import { Component, AfterViewInit, EventEmitter, ElementRef, forwardRef, Input, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, NgControl, NG_VALUE_ACCESSOR } from '@angular/forms';

import { MessageService } from '../../../core/services';
import { ajustarUrl } from '../../../core/utils';

@Component({
    selector: 'sgt-url',
    templateUrl: 'url.component.html',
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => UrlComponent), multi: true },
    ]
})
export class UrlComponent implements AfterViewInit, ControlValueAccessor {
    @Input() ngModel: any;
    @Output() ngModelChange = new EventEmitter<string>();

    @Input() required: any;
    @Input() disabled: any;
    @Input() readonly: any;
    @Input() maxlength: any;
    @Input() ngControl: NgControl;
    @Input() autofocus = false;

    @ViewChild('inputUrl') inputUrl: ElementRef;
    inputUrlNativeElement: any;

    propagateChange: any = () => {};

    constructor(private el: ElementRef,
                private messageService: MessageService) { }


    ngAfterViewInit() {
        this.inputUrlNativeElement = this.inputUrl.nativeElement;

        if (this.autofocus) {
            jQuery(this.inputUrlNativeElement).focus();
        }
    }

    /** Visita a URL informada no input */
    goToUrl() {
        let url: string = this.inputUrlNativeElement.value;
        if (url && url.trim().length !== 0) {
            // Ajustando a URL caso ela não esta correta para abrir
            url = ajustarUrl(url);
            // Abrindo em uma nova aba
            window.open(url, '_blank');
        } else {
            this.messageService.info('Nenhuma URL foi informada', 'Informação');
            jQuery(this.inputUrlNativeElement).focus();
        }
    }

    /** Ao digitar no input */
    onKeyup(e: KeyboardEvent) {
        this.propagateChange(this.inputUrlNativeElement.value);
    }

    /** Quando recebe um valor */
    writeValue(value: number) {
        if (!this.inputUrlNativeElement) {
            return;
        }

        if (value) {
            this.inputUrlNativeElement.value = value;
        } else {
            this.inputUrlNativeElement.value = '';
        }
    }

    /** Propaga as alterações realizadas no input */
    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() { }
}
